import React from 'react';
import DisplayGroup from './display-group';

class DisplayLayer extends React.Component {
  constructor(props){
    super(props);
    
    this.state = {
      content: null,
    }
    this.renderAttributes = this.renderAttributes.bind(this);
  }
  
  renderAttributes(){
    const {data} = this.props;
    const {display} = data;
    let content =[];
    if(display && display.length>0) {
      display.map((obj, idx) => {
        content.push(<DisplayGroup key={`${obj.title}-${idx}`} title={obj.title} children={obj.children} subGroup={obj.subGroup}/>)
      })
    }
    return content
  }
  render(){
    return (
      <div>
        {this.renderAttributes()}
      </div>
    )
  }
}

export default DisplayLayer;
